import { router } from '@/router'
import { DateTime } from 'luxon'
import _ from 'lodash'

const options = {
  user_role: [
    { value: 'customer', text: 'Customer' },
    { value: 'operator', text: 'Operator' },
    { value: 'admin', text: 'Administrator' }
  ],

  project_type: [
    { value: 'spot', text: 'Spot' },
    { value: 'manufacturing', text: 'Manufacturing' },
    { value: 'yacht_racing', text: 'Yacht Racing' },
    { value: 'automotive', text: 'Automotive' },
    { value: 'monitoring', text: 'Monitoring' }
  ],

  structure_type: [
    { value: 'car', text: 'Car' },
    { value: 'boat', text: 'Boat' },
    { value: 'wind_turbine', text: 'Wind turbine' },
    { value: 'rig', text: 'Rig' },
    { value: 'boom', text: 'Boom' },
    { value: 'shrouds', text: 'Shrouds' },
    { value: 'other', text: 'Other' }
  ]
}

const formatProjectType = (key) => {
  let typeArray = options.project_type.map((data) => {
    if (key === data.value) { return data.text }
  })
  return _.remove(typeArray, undefined)[0]
}

const formatStructureType = (key) => {
  let typeArray = options.structure_type.map((data) => {
    if (key === data.value) { return data.text }
  })
  return _.remove(typeArray, undefined)[0]
}

const formatUserRole = (key) => {
  let typeArray = options.user_role.map((data) => {
    if (key === data.value) { return data.text }
  })
  return _.remove(typeArray, undefined)[0]
}

const getValue = (entity, field, value) => {
  let result = value
  options[entity + '_' + field].forEach((option) => {
    if (option.value === value) {
      result = option.text
    }
  })
  return result
}

const userNormalizer = (entity, resource) => {
  return {
    id: resource.id,
    first_name: resource.first_name,
    last_name: resource.last_name,
    company: resource.company,
    role: getValue(entity, 'role', resource.role),
    email: resource.email
  }
}

const projectNormalizer = (entity, resource) => {
  let structures = resource.project_structures.map((projectStructure) => {
    return {
      name: projectStructure.structure.card_name,
      url: router.resolve({ name: 'Show object', params: { id: projectStructure.structure.id } }).href
    }
  })
  return {
    id: resource.id,
    type: getValue(entity, 'type', resource.type),
    name: resource.name,
    relatedStructures: structures
  }
}

const dashboardNormalizer = (project) => {
  if (project.recent_checklists_items[0]) {
    let recentItems = project.recent_checklists_items
    project.recent_items = recentItems

    project.recent_items.forEach((item, index) => {
      let notes = project.recent_items[index].notes
      notes = (typeof notes === 'string') ? notes.substring(0, 120) : null
      project.recent_items[index].notes = (notes && project.recent_items[index].notes > notes) ? notes + '...' : notes
    })

    delete project.recent_checklists_items
    return project
  }
}

const checklistNormalizer = (entity, resource) => {
  let ProjectUrl = router.resolve({ name: 'All projects' }).href
  let StructureUrl = router.resolve({ name: 'All objects' }).href
  let ChecklistUrl = router.resolve({ name: 'Show inspection', params: { id: resource.id } }).href
  return {
    id: resource.id,
    type: getValue('project', 'type', resource.type),
    name: resource.name,
    location: resource.location,
    date: DateTime.fromISO(resource.updated_at).toLocaleString(DateTime.DATETIME_FULL),
    project: "<a href='" + ProjectUrl + "'>" +
      resource.project.name +
      '</a>',
    structure: "<a href='" + StructureUrl + "'>" +
      resource.structure.name +
      '</a>',
    status: resource.checked,
    checklist_show: "<a href='" + ChecklistUrl + "'>More details</a>",
    defective: resource.defective
  }
}

const structureNormalizer = (entity, resource) => {
  return {
    id: resource.id,
    type: getValue(entity, 'type', resource.type),
    code: resource.code,
    name: resource.name,
    model: resource.model,
    manufacturer: resource.manufacturer,
    manufacture_year: resource.manufacture_year,
    actionOptions: { 'deleteable': resource.deleteable }
  }
}

const normalizer = (entity, resource) => {
  switch (entity) {
    case 'user':
      return userNormalizer(entity, resource)
    case 'project':
      return projectNormalizer(entity, resource)
    case 'structure':
      return structureNormalizer(entity, resource)
    case 'checklist':
      return checklistNormalizer(entity, resource)
    case 'dashboard':
      return dashboardNormalizer(resource)
    default:
      return resource
  }
}

export {
  normalizer,
  options,
  formatProjectType,
  formatStructureType,
  formatUserRole
}



// WEBPACK FOOTER //
// ./src/utils/resourceNormalizer.js